import React from 'react';
import { AlertCircle, CheckCircle, FileText, Clock, XCircle, Euro, Mail } from 'lucide-react';

const THGNoticesSection = () => {
  const notices = [
    {
      title: '1. Anspruchsberechtigung',
      icon: CheckCircle,
      items: [
        'THG-Quoten koennen fuer reine Batterie-Elektrofahrzeuge (BEV) beantragt werden.',
        'Plug-in-Hybride (PHEV) sind nicht berechtigt.',
        'Privatkunden muessen Halter des Fahrzeugs sein oder eine Halter-Vollmacht besitzen.',
        'Unternehmen muessen sicherstellen, dass die anmeldende Person vertretungsberechtigt ist.'
      ]
    },
    {
      title: '2. Benoetigte Unterlagen',
      icon: FileText,
      items: [
        'Fuer die Registrierung werden benoetigt:',
        'Zulassungsbescheinigung Teil I (Fahrzeugschein), vollstaendig und gut lesbar',
        'Bei Unternehmen: ggf. Halternachweis oder interner Berechtigungsnachweis',
        'Bei Ladepunkten: Betreiberbestaetigung und technische Nachweise'
      ]
    },
    {
      title: '3. Einreichung und Pruefung',
      icon: Clock,
      items: [
        'Nach dem Upload Ihrer Dokumente:',
        'prueft Grid Balance die Daten,',
        'reicht diese bei einem Vermarktungspartner ein,',
        'dieser prueft sie erneut und reicht sie beim Umweltbundesamt (UBA) ein.',
        'Grid Balance uebernimmt saemtliche Schritte organisatorisch – jedoch entscheidet letztlich das UBA ueber die Anerkennung der Quote.'
      ]
    },
    {
      title: '4. Besonderheiten der Abtretung',
      icon: AlertCircle,
      items: [
        'Die Abtretung der THG-Quote erfolgt aufschiebend bedingt.',
        'Das bedeutet: Eine Auszahlung ist nur moeglich, wenn Grid Balance selbst eine Verguetung vom Vermarktungspartner erhaelt.',
        'Wird keine Verguetung erzielt, erhaelt der Kunde keine Auszahlung, kann die Quote jedoch anderweitig vermarkten.'
      ]
    },
    {
      title: '5. Marktpreis & Auszahlung',
      icon: Euro,
      items: [
        'Die Hoehe der THG-Quotenverguetung haengt vom Marktpreis ab.',
        'Es gibt keine gesetzliche Preisgarantie.',
        'Termine der Auszahlung koennen variieren, da externe Behoerden und Vermarkter beteiligt sind.',
        'Grid Balance buendelt Auszahlungen und leitet sie nach Eingang weiter.'
      ]
    },
    {
      title: '6. Haeufige Gruende fuer Ablehnung durch das UBA',
      icon: XCircle,
      items: [
        'unlesbare oder unvollstaendige Fahrzeugscheine',
        'falscher Fahrzeugtyp (z. B. Hybride)',
        'Halterdaten stimmen nicht ueberein',
        'doppelte Anmeldung derselben Quote',
        'Bitte achten Sie daher unbedingt auf vollstaendige und korrekte Angaben.'
      ]
    },
    {
      title: '7. Pflichten des Kunden',
      icon: CheckCircle,
      items: [
        'Bereitstellung vollstaendiger, richtiger und aktueller Informationen',
        'unverzuegliche Meldung von Aenderungen (Halterwechsel, Stilllegung, Abmeldung)',
        'keine parallele Vermarktung ueber andere Anbieter'
      ]
    },
    {
      title: '8. Kontakt',
      icon: Mail,
      items: [
        'Bei Fragen zur THG-Quote oder zur Abwicklung steht Ihnen Grid Balance jederzeit zur Verfuegung.'
      ]
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-muted/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
            Wichtige Hinweise zur THG-Quote
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Die THG-Quote (Treibhausgasminderungsquote) ist ein gesetzlich geregeltes Instrument, 
            mit dem Betreiber von Elektrofahrzeugen ihre eingesparte CO2-Menge zertifizieren und an 
            quotenpflichtige Unternehmen (z. B. Mineraloelkonzerne) verkaufen koennen. Grid Balance 
            unterstuetzt Sie bei der Registrierung, Abwicklung und Vermittlung der Quote.
          </p>
        </div>

        <div className="space-y-6">
          {notices?.map((notice, index) => {
            const IconComponent = notice?.icon;
            return (
              <div
                key={index}
                className="bg-card rounded-xl p-6 md:p-8 shadow-sm border border-border hover:shadow-md transition-shadow"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-primary" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-heading font-semibold text-foreground mb-4">
                      {notice?.title}
                    </h3>
                    <ul className="space-y-2">
                      {notice?.items?.map((item, itemIndex) => (
                        <li
                          key={itemIndex}
                          className="text-muted-foreground leading-relaxed flex items-start gap-2"
                        >
                          <span className="text-primary mt-1.5 flex-shrink-0">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default THGNoticesSection;